import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import taxbill, { taxbillSaga } from './taxbill';
import taxbills, { taxbillsSaga } from './taxbills';


const payModule = combineReducers({
  taxbills,
  taxbill,
});

export function* payModuleSaga() {
  yield all([taxbillsSaga(), taxbillSaga()]);
}

export default payModule;
